import { render, staticRenderFns } from "./CellRendererStatusReg.vue?vue&type=template&id=976585b4&"
import script from "./CellRendererStatusReg.vue?vue&type=script&lang=js&"
export * from "./CellRendererStatusReg.vue?vue&type=script&lang=js&"
import style0 from "./CellRendererStatusReg.vue?vue&type=style&index=0&id=976585b4&prod&lang=scss&scpoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports